import { ConfigOption } from "@kre-form/core";
import {
  KreFormFieldText,
  KreFormFieldTextI18n,
  KreFormFieldTextArea,
  KreFormFieldNumber,
  KreFormFieldPassWord,
  KreFormFieldRadio,
  KreFormFieldRadioGroup,
  KreFormFieldCheckbox,
  KreFormFieldCheckboxGroup,
  KreFormFieldSelect,
  KreFormFieldDateTime,
  KreFormFieldImage,
  KreFormFieldUpload,
  KreFormFieldLookUp,
  KreFormFieldHTML,
  KreFormFieldLine,
  KreFormDragDrop,
  KreFormFieldAnchor,
} from "./types/types";
import { KreFormWrapperFormField } from "./wrappers/wrappers";
import { KreFormFieldGroup } from "./templates/group";
import { KreFormFieldRepeat } from "./templates/repeat/index";
import { DeonFieldOverTime } from "./templates/overtime/index";
import { KreFormFieldPanel } from "./templates/panel";
import { KreFormFieldTabular } from "./templates/tabular";
import { KreFormFieldTabularItem } from "./templates/tabular-item";
import { KreFormFieldSwitch } from "./types/switch";

export const FIELD_TYPE_COMPONENTS = [
  // types
  KreFormFieldText,
  KreFormFieldTextI18n,
  KreFormFieldTextArea,
  KreFormFieldNumber,
  KreFormFieldPassWord,
  KreFormFieldRadio,
  KreFormFieldRadioGroup,
  KreFormFieldCheckbox,
  KreFormFieldCheckboxGroup,
  KreFormFieldSelect,
  KreFormFieldDateTime,
  KreFormFieldImage,
  KreFormFieldUpload,
  KreFormFieldLookUp,
  KreFormFieldHTML,
  KreFormFieldLine,
  KreFormDragDrop,
  KreFormFieldAnchor,
  KreFormFieldSwitch,
  // templates
  KreFormFieldGroup,
  KreFormFieldRepeat,
  DeonFieldOverTime,

  // wrappers
  KreFormWrapperFormField,
  KreFormFieldPanel,
  KreFormFieldTabular,
  KreFormFieldTabularItem,
];

export const BOOTSTRAP_KreFORM_CONFIG: ConfigOption = {
  types: [
    {
      name: "text",
      component: KreFormFieldText,
      wrappers: ["form-field"],
    },
    {
      name: "texti18n",
      component: KreFormFieldTextI18n,
      wrappers: ["form-field"],
    },
    {
      name: "textarea",
      component: KreFormFieldTextArea,
      wrappers: ["form-field"],
    },
    {
      name: "numbers",
      component: KreFormFieldNumber,
      wrappers: ["form-field"],
    },
    {
      name: "password",
      component: KreFormFieldPassWord,
      wrappers: ["form-field"],
    },
    {
      name: "switch",
      component: KreFormFieldSwitch,
      wrappers: ["form-field"],
    },
    {
      name: "radio",
      component: KreFormFieldRadio,
      wrappers: ["form-field"],
    },
    {
      name: "radiogroup",
      component: KreFormFieldRadioGroup,
      wrappers: ["form-field"],
    },
    {
      name: "checkbox",
      component: KreFormFieldCheckbox,
      wrappers: ["form-field"],
    },
    {
      name: "checkboxgroup",
      component: KreFormFieldCheckboxGroup,
      wrappers: ["form-field"],
    },
    {
      name: "select",
      component: KreFormFieldSelect,
      wrappers: ["form-field"],
    },
    {
      name: "datetime",
      component: KreFormFieldDateTime,
      wrappers: ["form-field"],
    },
    {
      name: "image",
      component: KreFormFieldImage,
      wrappers: ["form-field"],
    },
    {
      name: "upload",
      component: KreFormFieldUpload,
      wrappers: ["form-field"],
    },
    // {
    //   name: "lookup",
    //   component: KreFormFieldLookUp,
    //   wrappers: ["form-field"],
    // },
    {
      name: "htmlcontent",
      component: KreFormFieldHTML,
      wrappers: ["form-field"],
    },
    {
      name: "line",
      component: KreFormFieldLine,
      wrappers: ["form-field"],
    },
    {
      name: "drag-drop",
      component: KreFormDragDrop,
    },
    {
      name: "anchor",
      component: KreFormFieldAnchor,
      wrappers: ["form-field"],
    },

    { name: "group", component: KreFormFieldGroup },
    { name: "repeat", component: KreFormFieldRepeat },
    { name: "panel", component: KreFormFieldPanel },
    // { name: "overTime", component: DeonFieldOverTime },

    //{ name: "tabular", component: KreFormFieldTabular },
    // { name: "tabularitem", component: KreFormFieldTabularItem },
  ],
  wrappers: [{ name: "form-field", component: KreFormWrapperFormField }],
};
